import { render, staticRenderFns } from "./PerformanceCheck.vue?vue&type=template&id=010ec0d6&scoped=true&"
import script from "./PerformanceCheck.vue?vue&type=script&lang=js&"
export * from "./PerformanceCheck.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCheck.vue?vue&type=style&index=0&id=010ec0d6&lang=stylus&scoped=true&"
import style1 from "./PerformanceCheck.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ec0d6",
  null
  
)

export default component.exports